:root {
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", system-ui, -apple-system, sans-serif;
  line-height: 1.5;
  font-weight: 400;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  --xiaocai-safe-top: env(safe-area-inset-top, 0px);
  --xiaocai-safe-right: env(safe-area-inset-right, 0px);
  --xiaocai-safe-bottom: env(safe-area-inset-bottom, 0px);
  --xiaocai-safe-left: env(safe-area-inset-left, 0px);
  --xiaocai-app-viewport-height: 100svh;
}

* {
  box-sizing: border-box;
}

html,
body,
#root {
  height: 100%;
  min-height: 100%;
  overflow-x: hidden;
}

#root {
  height: var(--xiaocai-app-viewport-height);
  min-height: var(--xiaocai-app-viewport-height);
}

body {
  margin: 0;
  background: #f5f7fb;
  color: #0f172a;
  overscroll-behavior-x: none;
  -webkit-text-size-adjust: 100%;
}

button,
input,
textarea,
select {
  appearance: none;
  -webkit-appearance: none;
  border-radius: 0;
  font: inherit;
  line-height: 1.4;
}

input,
textarea {
  font-family: inherit;
}

.xiaocai-chat-page,
.xiaocai-settings-page,
.settings-page,
.core-entry-page {
  min-height: var(--xiaocai-app-viewport-height);
}

@media (max-width: 767px) {
  input,
  textarea,
  select {
    font-size: 16px;
  }
}


.xiaocai-chat-page .flare-composer::before {
  color: var(--flare-text-secondary);
  content: '描述你的采购目标、用途、预算或约束，小采会先帮你判断下一步。';
  display: block;
  font-size: 13px;
  line-height: 1.5;
  margin: 0 auto 8px;
  max-width: 980px;
}

/* 保留过程信息，但去除容器化视觉（无底色/边框/阴影） */
.xiaocai-chat-page .flare-thinking-card.ant-card,
.xiaocai-chat-page .flare-meta-card.ant-card,
.xiaocai-chat-page .flare-process-meta-card.ant-card,
.xiaocai-chat-page .flare-error-compact-card.ant-card,
.xiaocai-chat-page .flare-ui-card.ant-card,
.xiaocai-chat-page .flare-field-progress-card.ant-card {
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.xiaocai-chat-page .flare-thinking-card.ant-card .ant-card-body,
.xiaocai-chat-page .flare-meta-card.ant-card .ant-card-body,
.xiaocai-chat-page .flare-process-meta-card.ant-card .ant-card-body,
.xiaocai-chat-page .flare-error-compact-card.ant-card .ant-card-body,
.xiaocai-chat-page .flare-ui-card.ant-card .ant-card-body,
.xiaocai-chat-page .flare-field-progress-card.ant-card .ant-card-body {
  padding: 6px 0 !important;
}

.xiaocai-chat-page .flare-markdown-content {
  counter-reset: flare-ordered-item;
}

.xiaocai-chat-page .flare-markdown-content ol.flare-markdown-list {
  list-style: none;
  padding-left: 0;
}

.xiaocai-chat-page .flare-markdown-content ol.flare-markdown-list > li {
  counter-increment: flare-ordered-item;
  margin-left: 2em;
  position: relative;
}

.xiaocai-chat-page .flare-markdown-content ol.flare-markdown-list > li::before {
  content: counter(flare-ordered-item) ".";
  left: -2em;
  position: absolute;
  text-align: right;
  width: 1.6em;
}

.settings-connector-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.settings-connector-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
}

.settings-connector-icon {
  align-items: center;
  background: var(--xiaocai-brand-primary-subtle-text);
  border-radius: 8px;
  color: var(--xiaocai-primary-hover);
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.settings-status-dot {
  border-radius: 999px;
  display: inline-block;
  height: 8px;
  width: 8px;
}

.settings-connector-actions {
  border-top: 1px solid #f1f5f9;
  margin-top: 2px;
  padding-top: 8px;
}

.settings-visibility-item {
  align-items: center;
  display: flex;
  justify-content: space-between;
}


.xiaocai-chat-page .flare-chat-workspace {
  --flare-seg-track-bg: var(--xiaocai-primary-soft);
  --flare-seg-track-border: var(--xiaocai-primary-border-soft);
  --flare-seg-item-color: #5c6b94;
  --flare-seg-item-hover-color: var(--xiaocai-primary-strong);
  --flare-seg-item-selected-color: var(--xiaocai-primary-dark);
  --flare-seg-item-selected-bg: #ffffff;
}

/* 右侧 Canvas 报告是 FLARE 通用组件；这里仅做 xiaocai 壳层的防溢出约束。 */
:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-panel,
:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-content,
:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-content-main,
:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-analysis-support-panel {
  max-width: 100%;
  min-width: 0;
}

:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-panel article,
:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-panel p,
:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-panel li,
:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-panel blockquote {
  overflow-wrap: anywhere;
  word-break: break-word;
}

:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-panel table {
  max-width: 100%;
  min-width: 0 !important;
  table-layout: fixed;
}

:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-panel th,
:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-panel td {
  overflow-wrap: anywhere;
  white-space: normal !important;
  word-break: break-word;
}

:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-panel pre {
  max-width: 100%;
  overflow-x: auto;
}

:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-canvas-content-main article {
  min-width: 0;
  overflow-x: auto !important;
  overflow-y: visible !important;
}

:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-markdown-content {
  max-width: 100%;
  overflow-x: auto;
}

:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-markdown-content table {
  max-width: 100%;
  min-width: 0 !important;
  table-layout: fixed;
}

:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-markdown-content th,
:is(.xiaocai-chat-page, .xiaocai-settings-page) .flare-markdown-content td {
  overflow-wrap: anywhere;
  white-space: normal !important;
  word-break: break-word;
}

.xiaocai-chat-page .flare-composer-quick-mode-toggle {
  background: var(--xiaocai-primary-soft);
  border-color: var(--xiaocai-primary-border);
  color: var(--xiaocai-primary-strong);
}

.xiaocai-chat-page .flare-composer-quick-mode-toggle:hover {
  background: var(--xiaocai-primary-soft-hover);
  border-color: var(--xiaocai-primary-border-strong);
  color: #1937b6;
}

.xiaocai-chat-page .flare-composer-quick-mode-toggle.is-active {
  background: var(--xiaocai-primary-soft-hover);
  border-color: var(--xiaocai-primary);
  color: var(--xiaocai-primary-dark);
}

.xiaocai-chat-page .flare-composer-quick-mode-toggle.is-active .flare-composer-quick-mode-state {
  color: var(--xiaocai-primary-hover);
}

.xiaocai-chat-page .flare-composer-menu-item.is-checked:not(:disabled) {
  color: var(--xiaocai-primary-hover);
}

.xiaocai-chat-page .flare-composer-menu-item-toggle.ant-switch.ant-switch-checked {
  background: var(--xiaocai-primary);
  border-color: var(--xiaocai-primary);
}

.xiaocai-chat-page .flare-workspace-action-zone-button,
.xiaocai-chat-page .flare-workspace-mode-hint-apply {
  background: var(--xiaocai-primary-soft);
  border-color: var(--xiaocai-primary-border);
  color: var(--xiaocai-primary-strong);
}

.xiaocai-chat-page .flare-workspace-action-zone-button:hover {
  background: var(--xiaocai-primary-soft-hover);
  border-color: var(--xiaocai-primary-border-strong);
}

.xiaocai-chat-page .flare-workspace-workbench-trigger.is-active.ant-btn {
  background: rgba(var(--xiaocai-primary-rgb), 0.14);
  color: var(--xiaocai-primary-strong);
}

.xiaocai-chat-page .flare-workspace-context-gauge {
  background: conic-gradient(var(--xiaocai-primary) var(--flare-context-ratio), rgba(15, 23, 42, 0.12) 0);
}

.xiaocai-chat-page .flare-workspace-context-popover-chart {
  background: rgba(var(--xiaocai-primary-rgb), 0.16);
  border-color: rgba(var(--xiaocai-primary-rgb), 0.26);
}

.xiaocai-chat-page .flare-workspace-context-popover-chart-fill {
  background: var(--xiaocai-primary);
}


.xiaocai-settings-page .flare-chat-workspace,
.xiaocai-chat-page .flare-chat-workspace {
  --flare-seg-track-bg: var(--xiaocai-primary-soft);
  --flare-seg-track-border: var(--xiaocai-primary-border-soft);
  --flare-seg-item-color: #5c6b94;
  --flare-seg-item-hover-color: var(--xiaocai-primary-strong);
  --flare-seg-item-selected-color: var(--xiaocai-primary-dark);
  --flare-seg-item-selected-bg: #ffffff;
}

.xiaocai-settings-page .flare-composer-quick-mode-toggle,
.xiaocai-chat-page .flare-composer-quick-mode-toggle {
  background: var(--xiaocai-primary-soft);
  border-color: var(--xiaocai-primary-border);
  color: var(--xiaocai-primary-strong);
}

.xiaocai-settings-page .flare-composer-quick-mode-toggle:hover,
.xiaocai-chat-page .flare-composer-quick-mode-toggle:hover {
  background: var(--xiaocai-primary-soft-hover);
  border-color: var(--xiaocai-primary-border-strong);
  color: #1937b6;
}


.xiaocai-settings-page .flare-composer-quick-mode-toggle.is-active,
.xiaocai-chat-page .flare-composer-quick-mode-toggle.is-active {
  background: var(--xiaocai-primary-soft-hover);
  border-color: var(--xiaocai-primary);
  color: var(--xiaocai-primary-dark);
}

.xiaocai-settings-page .flare-composer-quick-mode-toggle.is-active .flare-composer-quick-mode-state,
.xiaocai-chat-page .flare-composer-quick-mode-toggle.is-active .flare-composer-quick-mode-state {
  color: var(--xiaocai-primary-hover);
}

.xiaocai-settings-page .flare-composer-menu-item.is-checked:not(:disabled),
.xiaocai-chat-page .flare-composer-menu-item.is-checked:not(:disabled) {
  color: var(--xiaocai-primary-hover);
}

.xiaocai-settings-page .flare-composer-menu-item-toggle.ant-switch.ant-switch-checked,
.xiaocai-chat-page .flare-composer-menu-item-toggle.ant-switch.ant-switch-checked {
  background: var(--xiaocai-primary);
  border-color: var(--xiaocai-primary);
}

.xiaocai-settings-page .flare-workspace-action-zone-button,
.xiaocai-settings-page .flare-workspace-mode-hint-apply,
.xiaocai-chat-page .flare-workspace-action-zone-button,
.xiaocai-chat-page .flare-workspace-mode-hint-apply {
  background: var(--xiaocai-primary-soft);
  border-color: var(--xiaocai-primary-border);
  color: var(--xiaocai-primary-strong);
}

.xiaocai-settings-page .flare-workspace-action-zone-button:hover,
.xiaocai-chat-page .flare-workspace-action-zone-button:hover {
  background: var(--xiaocai-primary-soft-hover);
  border-color: var(--xiaocai-primary-border-strong);
}

.xiaocai-settings-page .flare-workspace-workbench-trigger.is-active.ant-btn,
.xiaocai-chat-page .flare-workspace-workbench-trigger.is-active.ant-btn {
  background: rgba(var(--xiaocai-primary-rgb), 0.14);
  color: var(--xiaocai-primary-strong);
}

.xiaocai-settings-page .flare-workspace-context-gauge,
.xiaocai-chat-page .flare-workspace-context-gauge {
  background: conic-gradient(var(--xiaocai-primary) var(--flare-context-ratio), rgba(15, 23, 42, 0.12) 0);
}

.xiaocai-settings-page .flare-workspace-context-popover-chart,
.xiaocai-chat-page .flare-workspace-context-popover-chart {
  background: rgba(var(--xiaocai-primary-rgb), 0.16);
  border-color: rgba(var(--xiaocai-primary-rgb), 0.26);
}

.xiaocai-settings-page .flare-workspace-context-popover-chart-fill,
.xiaocai-chat-page .flare-workspace-context-popover-chart-fill {
  background: var(--xiaocai-primary);
}

/* Brand-blue interaction refinements: button text / hover / focus */
.xiaocai-settings-page .flare-chat-workspace .ant-btn-primary,
.xiaocai-chat-page .flare-chat-workspace .ant-btn-primary {
  background: var(--xiaocai-primary) !important;
  border-color: var(--xiaocai-primary) !important;
  color: #ffffff !important;
}

.xiaocai-settings-page .flare-chat-workspace .ant-btn-primary:hover,
.xiaocai-chat-page .flare-chat-workspace .ant-btn-primary:hover {
  background: var(--xiaocai-primary-hover) !important;
  border-color: var(--xiaocai-primary-hover) !important;
  color: #ffffff !important;
}

.xiaocai-settings-page .flare-chat-workspace .ant-btn-primary:focus-visible,
.xiaocai-settings-page .flare-chat-workspace .ant-btn-primary:focus,
.xiaocai-chat-page .flare-chat-workspace .ant-btn-primary:focus-visible,
.xiaocai-chat-page .flare-chat-workspace .ant-btn-primary:focus {
  box-shadow: 0 0 0 3px rgba(var(--xiaocai-primary-rgb), 0.20) !important;
  outline: none !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-send-button,
.xiaocai-chat-page .flare-chat-workspace .flare-send-button {
  color: #ffffff !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-send-button:hover,
.xiaocai-chat-page .flare-chat-workspace .flare-send-button:hover {
  color: #ffffff !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-send-button-shortcut,
.xiaocai-chat-page .flare-chat-workspace .flare-send-button-shortcut {
  color: rgba(255, 255, 255, 0.92) !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-attach-button.ant-btn,
.xiaocai-settings-page .flare-chat-workspace .flare-workspace-icon-action.ant-btn,
.xiaocai-settings-page .flare-chat-workspace .flare-workspace-footer-config-entry.ant-btn,
.xiaocai-chat-page .flare-chat-workspace .flare-attach-button.ant-btn,
.xiaocai-chat-page .flare-chat-workspace .flare-workspace-icon-action.ant-btn,
.xiaocai-chat-page .flare-chat-workspace .flare-workspace-footer-config-entry.ant-btn {
  color: var(--xiaocai-primary-hover) !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-attach-button.ant-btn:hover,
.xiaocai-settings-page .flare-chat-workspace .flare-workspace-icon-action.ant-btn:hover,
.xiaocai-settings-page .flare-chat-workspace .flare-workspace-footer-config-entry.ant-btn:hover,
.xiaocai-chat-page .flare-chat-workspace .flare-attach-button.ant-btn:hover,
.xiaocai-chat-page .flare-chat-workspace .flare-workspace-icon-action.ant-btn:hover,
.xiaocai-chat-page .flare-chat-workspace .flare-workspace-footer-config-entry.ant-btn:hover {
  background: var(--xiaocai-brand-primary-subtle-text) !important;
  color: var(--xiaocai-primary-strong) !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-attach-button.ant-btn:focus-visible,
.xiaocai-settings-page .flare-chat-workspace .flare-workspace-icon-action.ant-btn:focus-visible,
.xiaocai-settings-page .flare-chat-workspace .flare-workspace-footer-config-entry.ant-btn:focus-visible,
.xiaocai-chat-page .flare-chat-workspace .flare-attach-button.ant-btn:focus-visible,
.xiaocai-chat-page .flare-chat-workspace .flare-workspace-icon-action.ant-btn:focus-visible,
.xiaocai-chat-page .flare-chat-workspace .flare-workspace-footer-config-entry.ant-btn:focus-visible {
  box-shadow: 0 0 0 3px rgba(var(--xiaocai-primary-rgb), 0.18) !important;
  outline: none !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-composer-box:focus-within,
.xiaocai-settings-page .flare-chat-workspace .flare-composer-box.is-drag-over,
.xiaocai-chat-page .flare-chat-workspace .flare-composer-box:focus-within,
.xiaocai-chat-page .flare-chat-workspace .flare-composer-box.is-drag-over {
  border-color: var(--xiaocai-primary) !important;
  box-shadow: 0 0 0 3px rgba(var(--xiaocai-primary-rgb), 0.18) !important;
}

/* User message bubble override (chat-core currently locks default theme tokens) */
.xiaocai-settings-page .flare-chat-workspace .flare-message-row.is-user .flare-message-bubble.ant-card,
.xiaocai-chat-page .flare-chat-workspace .flare-message-row.is-user .flare-message-bubble.ant-card {
  background: var(--xiaocai-primary) !important;
  border-color: var(--xiaocai-primary) !important;
  box-shadow: 0 8px 22px rgba(var(--xiaocai-primary-rgb), 0.30) !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-message-row.is-user .flare-message-copy-button,
.xiaocai-chat-page .flare-chat-workspace .flare-message-row.is-user .flare-message-copy-button {
  color: rgba(255, 255, 255, 0.96) !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-message-row.is-user .flare-message-copy-button:hover,
.xiaocai-chat-page .flare-chat-workspace .flare-message-row.is-user .flare-message-copy-button:hover {
  background: rgba(255, 255, 255, 0.14) !important;
  color: #ffffff !important;
}

.xiaocai-settings-page .flare-chat-workspace .flare-message-row.is-user .flare-message-copy-button:focus-visible,
.xiaocai-chat-page .flare-chat-workspace .flare-message-row.is-user .flare-message-copy-button:focus-visible {
  box-shadow: 0 0 0 3px rgba(219, 229, 255, 0.65) !important;
  outline: none !important;
}
